import {lazy, Suspense} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import Loader from '../components/Loader'

const Login = lazy(() => import('../pages/Login'))
const AdminDashboard = lazy(() => import('../pages/AdminDashboard'))
const User = lazy(() => import('../pages/User'))

const { baseRoute } = window['appconfig']

export const MyRoutes = () => {
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    return(
        <BrowserRouter basename={baseRoute}>
            <Suspense fallback={<Loader/>}>
                <Routes>
                    {isLoggedIn === 'true' && <Route path="/admin" element={<AdminDashboard/>} />}
                    {isLoggedIn !== 'true' && <Route path="/login" element={<Login/>} />}
                    {isLoggedIn !== 'true' && <Route path="/" element={<User/>} />}
                    <Route path="/admin" element={isLoggedIn === 'true' ? <Navigate to="/admin" replace /> : <Navigate to="/login" replace />} />
                    <Route path="*" element={isLoggedIn === 'true' ? <Navigate to="/admin" replace /> : <Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}